// 查询项目详情
import request from "@/utils/request";

export function projectDetailApi(that, project_id, func) {
  request({
    url: '/v1.0/iwrs/project/detail',
    method: 'get',
    params: {
      id: project_id
    }
  }).then(res => {
    if (res && res.code === 0) {
      func(res)
    } else {
      that.$message.error(res.msg)
    }
  }).catch(res => {
    console.log(res.msg)
    that.$message.error('请求失败')
  })
}

// 发布到prod
export function publishPROD(data) {
  return request({
    url: '/v1.0/iwrs/public/pro/project',
    method: 'post',
    data
  })
}
